import React, { useRef, useState, useEffect } from 'react';
import {lang} from '../lang';
import api from '../api'

export default function BookingDelete(props) {
    const styles = props.styles;
    const [id, setID] = useState(0);
    const [cancelReason, setCancelReason] = useState('');
    const [error, setError] = useState(0);
    const [msg, setMsg] = useState('');
    const wrapperRef = useRef(null);

    // effect runs when props is updated
    useEffect(() => {
        if(props.booking){
            setID(props.booking.id);
        }
        // prefill cancel reason if provided
        if(props.booking && props.booking.cancel_reason){
            setCancelReason(props.booking.cancel_reason);
        }else{
            setCancelReason('');
        }
    }, [props]);

    // effect runs 
    useEffect(() => {
        if(props.display){
            document.addEventListener('mousedown', handleClickOutside);
        }
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        setError(0);
        // bug don't select booking
        if(id===0){
            setError(1);
            setMsg("Please select date");
            closeModal(event);
        }else if(cancelReason.trim()===''){
            setError(1);
            setMsg("Please provide cancel reason");
        }else{  // delete booking
            const user=localStorage.getItem('email');
            const ip=localStorage.getItem('ip');

            if(props.booking.title==="นัดหมายตรวจรายงาน"){
                const cmu_account=JSON.parse(localStorage.getItem('cmu_account'));
                const jsonData = {
                    id: id,
                    cancel_reason: cancelReason,
                    cancel_time: (new Date()).toISOString(),
                    cancel_by: cmu_account.prename_TH+' '+cmu_account.firstname_TH+' '+cmu_account.lastname_TH,
                    user: user,
                    ip: ip,
                }
                api.post(`assistant-bookings/cancel`, jsonData)
                .then(response => {
                    if(response.data.status==='ok'){
                        // props.setSuccess(1);
                        props.onSuccess();
                        props.setDisplay(false);
                    }else{
                        setError(1);
                        setMsg(response.data.message);
                    }
                })
                .catch(error => {
                    setError(1);
                    setMsg(error);
                });
            }else{
                const jsonData = {
                    id: id,
                    cancel_reason: cancelReason,
                    cancel_time: (new Date()).toISOString(),
                    cancel_by: props.booking.booking_by,
                    user: user,
                    ip: ip,
                }
                api.post(`rsvn/cancel`, jsonData)
                .then(response => {
                    if(response.data.status==='ok'){
                        // props.setSuccess(1);
                        props.onSuccess();
                        props.setDisplay(false);
                    }else{
                        setError(1);
                        setMsg(response.data.message);
                    }
                })
                .catch(error => {
                    setError(1);
                    setMsg(error);
                });
            }
        }
    };

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setError(0);
            props.setDisplay(false);
            document.removeEventListener('mousedown', handleClickOutside);
        }
    };

    const closeModal = (event) => {
        event.preventDefault();
        document.removeEventListener('mousedown', handleClickOutside);
        props.setDisplay(false);
    };

    if(!props.booking){
        return '';
    }

    return (
        <div className={`${styles["modal"]}`} ref={wrapperRef}>
            <div className={styles["modal-dialog"]}>
                <div className={styles["modal-header"]}>
                    <b>{lang('ยกเลิกการจอง: '+props.booking.room_name,'Delete Reservation: '+props.booking.room_name)}</b>
                    <button className={styles["modal-btn-close"]} onClick={(event)=>closeModal(event)}>X</button>
                </div>
            <div className={styles["modal-content"]}>
                {(error===1)?(
                <div className="notice danger">
                    <div><i className="fa-solid fa-triangle-exclamation"></i></div>
                    <div className="info">
                        <b>{lang('ไม่สามารถยกเลิกการจองได้', 'Can\'t cancel reservation.')}</b>
                        <p>{msg}</p>
                    </div>
                </div>
                ):''}
                <form>
                    {(props.booking && parseInt(props.booking.cancel) === 1 && (props.booking.cancel_time || props.booking.cancel_by))?(
                    <fieldset className="py-2">
                        <div className="cancel-meta">
                            {props.booking.cancel_time? <div><strong>{lang('เวลายกเลิก','Cancel time')}:</strong> {props.booking.cancel_time}</div>:''}
                            {props.booking.cancel_by? <div><strong>{lang('ยกเลิกโดย','Cancelled by')}:</strong> {props.booking.cancel_by}</div>:''}
                            {props.booking.cancel_reason? <div><strong>{lang('เหตุผลการยกเลิก','Cancel reason')}:</strong> {props.booking.cancel_reason}</div>:''}
                        </div>
                                
                    </fieldset>
                    ):''}
                    {(parseInt(props.booking.cancel) === 0 )?(
                    <fieldset>
                        <label htmlFor="cancel_reason">{lang('เหตุผลการยกเลิก','Cancel reason')}</label>
                        <textarea id="cancel_reason" name="cancel_reason" value={cancelReason} onChange={(e)=>setCancelReason(e.target.value)} rows={4} />
                    </fieldset>
                    ):""}
                    <fieldset>
                            {(error===0&&parseInt(props.booking.cancel) === 0)?(
                                <button type="button" className="btn btn-purple-dark" onClick={(e)=>handleSubmit(e)}>{lang('ยืนยัน','Confirm')}</button>
                            ):''}
                            <input type="hidden" id="id" name="id" value={(id)?id:0}/>
                            <button type="button" className={styles.cancel} onClick={(event)=>closeModal(event)}>{lang('ยกเลิก','Cancel')}</button>
                    </fieldset>
                </form>
                </div>
            </div>
        </div>
    );
}